import { AnimatedImages } from './AnimatedImages';

export type FunnelImage = {
  src: string;
  alt: string;
  width?: number;
  height?: number;
};

export type FunnelSprite = {
  name: string;
  color?: string;
  width?: number;
  height?: number;
};

type FunnelVideo = {
  src: string;
  alt: string;
  autoplay?: boolean;
  muted?: boolean;
  controls?: boolean;
};

export type ScreenBackground = {
  desktopImage: FunnelImage;
  mobileImage: FunnelImage;
};

export type BackgroundVideo = {
  src: string;
  poster: string;
};

// TODO think about merge with top
export type ScreenBackgroundType = {
  backgroundDesktop: string;
  backgroundMobile: string;
};

export enum MediaVariant {
  IMAGE = 'IMAGE',
  ANIMATED_IMAGE = 'ANIMATED_IMAGE',
  VIDEO = 'VIDEO',
}

interface ImageContent extends FunnelImage {
  variant: MediaVariant.IMAGE;
}

interface AnimatedImageContent {
  animatedImage: AnimatedImages;
  variant: MediaVariant.ANIMATED_IMAGE;
}

interface VideoContent extends FunnelVideo {
  variant: MediaVariant.VIDEO;
}

export type MediaData = ImageContent | AnimatedImageContent | VideoContent;
